import { api } from '../api';
import type { TaskDefinition } from '../api/types';

export interface TaskData {
  categories: string[];
  definitions: TaskDefinition[];
}

export class TaskService {
  private iconCache = new Map<string, string>();

  async fetchTaskData(
    select: string[] = [
      'name',
      'description',
      'category',
      'inputDescription',
      'outputDescription',
      'configDescription',
      'interaction',
    ]
  ): Promise<TaskData> {
    const [categories, definitions] = await Promise.all([
      api.tasks.categories(),
      api.tasks.list(select),
    ]);
    return { categories, definitions };
  }

  async getIcon(type: string): Promise<string> {
    const cached = this.iconCache.get(type);
    if (cached) return cached;
    const icon = await api.tasks.icon(type);
    this.iconCache.set(type, icon);
    return icon;
  }
}

export const taskService = new TaskService();
